import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] overflow-hidden">
      {/* Background image */}
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20wide%20panoramic%20illustration%20of%20a%20cozy%20reading%20scene%20with%20open%20webtoon%20pages%2C%20warm%20amber%20and%20golden%20lighting%2C%20Korean%20manhwa%20style%20art%2C%20soft%20glowing%20atmosphere%2C%20comfortable%20reading%20nook%2C%20evening%20vibe%2C%20cinematic%20composition%2C%20rich%20warm%20tones%2C%20storytelling%20aesthetic%2C%20clean%20and%20inviting&width=1800&height=600&seq=cta-reading-banner&orientation=landscape"
        alt="开始你的漫画之旅"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      {/* Triangular layout */}
      <div className="relative z-10 w-full h-full px-6 md:px-12 lg:px-20 flex flex-col justify-between py-12 md:py-16">
        {/* Top left: Title */}
        <div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
            现在就开启<br />你的漫画之旅
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
          {/* Bottom left: CTA button */}
          <Link
            to="/category/hanman"
            className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始免费阅读
            <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center">
              <i className="ri-arrow-right-line text-background-50 text-sm"></i>
            </span>
          </Link>

          {/* Bottom right: Description */}
          <div className="text-right">
            <p className="text-sm md:text-base text-white/70 leading-relaxed">
              每日更新 <strong className="text-white font-semibold">300+</strong> 章节<br />
              全部永久免费，随时随地畅享阅读
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}